import PropTypes from "prop-types";
import { useCallback, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import axios from "axios";

const getDynamicSx = (isMobile) => ({
  buttonSx: {
    width: "125px",
    height: "59px",
    color: "#000",
    opacity: "1",
    fontFamily: "Inter",
    fontSize: "24px",
    fontWeight: "600",
    borderRadius: "40px",
    padding: "0px",
    "&:hover": {
      background: "linear-gradient(180deg, rgba(255, 218, 11, 1.00) 0%, #FFB400 100%)",
    },
  },
  menuSx: {
    width: "auto",
    fontSize: "18px",
  },
});

export default function NavbarBuddhism({ path = "", charityName = "" }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMobile = useMediaQuery("(max-width:1350px)");
  const [drawerWidth, setDrawerWidth] = useState("50%");
  const { buttonSx } = getDynamicSx(isMobile);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [buddhismList, setBuddhismList] = useState([]);
  const navigate = useNavigate();
  let location = useLocation();

  useEffect(() => {
    fetchBuddhismListData();

    function updateDrawerWidth() {
      if (window.innerWidth < 768) {
        setDrawerWidth("75%");
      } else {
        setDrawerWidth("50%");
      }
    }

    window.addEventListener("resize", updateDrawerWidth);
    updateDrawerWidth(); // Initialize on first render

    return () => {
      window.removeEventListener("resize", updateDrawerWidth);
    };
    // eslint-disable-next-line
  }, [path, charityName, location.search]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDrawerOpen = () => {
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const handlePageLinkClick = useCallback(
    (e) => {
      const link = `/buddhismIntro?id=${e.currentTarget.getAttribute("data-id")}`;
      window.location.assign(link);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [navigate]
  );

  const fetchBuddhismListData = useCallback(async () => {
    try {
      const response = await axios.post("/api/website/getBuddhismList");
      setBuddhismList(response.data.data);
    } catch (error) {
      console.error("Error fetching article content:", error);
    }
  }, []);

  return (
    <div className="nav">
      <div className="nav-wrap">
        <Link to="/" className="logo-warp">
          <img className="logo" src="/asset/image/index/logo.png" alt="Logo" />
        </Link>
        <div className="logo-warp ml-[100px]">
          <h2 className="text-[#ffffff] font-semibold text-5xl mb-[15px]">{charityName}</h2>
        </div>
        {isMobile ? (
          <>
            <IconButton
              edge="start"
              color="inherit"
              size="large"
              aria-label="menu"
              onClick={handleDrawerOpen}
            >
              <MenuIcon
                sx={{
                  color: "#fff",
                  width: "40px",
                  height: "40px",
                }}
              />
            </IconButton>
            <Drawer
              anchor="right"
              open={isDrawerOpen}
              onClose={handleDrawerClose}
              disableScrollLock="true"
              PaperProps={{
                style: {
                  top: "100px",
                  width: drawerWidth,
                },
              }}
            >
              <div className="list-warp" onMouseLeave={handleDrawerClose}>
                {buddhismList.map((item) => (
                  <div key={item.id} style={{ padding: "10px 20px" }}>
                    <Link to={`/buddhismIntro?id=${item.id}`} onClick={handleDrawerClose}>
                      <span className="list-btn">{item.name}</span>
                    </Link>
                  </div>
                ))}
              </div>
            </Drawer>
          </>
        ) : (
          <div className="list-warp">
            {buddhismList.map((item) => (
              <div key={item.id} onMouseOver={handleOpen}>
                <Button
                  sx={buttonSx}
                  id={`fade-button-${item.id}`}
                  aria-controls={`fade-menu-${item.id}`}
                  aria-haspopup="true"
                  aria-expanded={Boolean(anchorEl)}
                >
                  <button data-id={item.id} onClick={handlePageLinkClick}>
                    <span className="list-btn">{item.name}</span>
                  </button>
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

NavbarBuddhism.propTypes = {
  path: PropTypes.string,
  charityName: PropTypes.string,
};
